module.exports = __webpack_public_path__ + "static/media/04-agenda.ec4aa75d.png";